export const getEmpresas = (state) => state.empresas.lista
export const getIsCarregandoListaEmpresas = (state) => state.empresas.isCarregandoLista
export const getEmpresaSelecionada = (state) => state.empresas.selecionado
export const getIsCarregandoEmpresa = (state) => state.empresas.isCarregandoEmpresa
export const getSelecionadaFiltro = (state) => state.empresas.selecionadaFiltro
export const getIsSavingEmpresa = (state) => state.empresas.isSaving
